import { render, staticRenderFns } from "./folder-list.vue?vue&type=template&id=868df8f6&scoped=true&"
import script from "./folder-list.vue?vue&type=script&lang=js&"
export * from "./folder-list.vue?vue&type=script&lang=js&"
import style0 from "./folder-list.vue?vue&type=style&index=0&id=868df8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868df8f6",
  null
  
)

export default component.exports